<template>
    <div class="">
        <div
            class="flex justify-content-center aling-items-center"
            :class="{
                'banner-vw': brand === 'vw',
                'banner-audi': brand === 'audi',
                'banner-seat': brand === 'seat',
                'banner-porsche': brand === 'porsche',
            }"
        ></div>
        <div class="flex justify-content-start my-4 mx-4">
            <div class="grid">
                <div class="col-12">
                    <h1>404</h1>
                    <h3 class="text-lg">El enlace al que intenta ingresar no existe.</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "NotFound",
    setup() {
        const brand = localStorage.getItem("brand") as string;

        return {
            brand,
        };
    },
});
</script>
